import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import InvoiceActions from '../../../../actions/invoiceActions';
import Helpers from '@Apis/helpers';
import AttachmentActions from '@Actions/attachmentActions';
import 'react-quill/dist/quill.bubble.css';
import './style.scss';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import ActivityLogActions from '@Actions/activityLogActions';
import AnalyticsActions from '@Actions/application/analyticsActions';
import ConsumptionLinesView from './ConsumptionLinesView';
import ViewLoadingSkull from '../../../Common/ViewLoadingSkull';
import CreditNoteForm from '../../CreditNote/CreditNoteForm';
import DeliveryChallanForm from '../../../Inventory/DeliveryChallan/DeliveryChallanForm';
import ViewDeliveryChallan from '@Components/Inventory/DeliveryChallan/ViewDeliveryChallan';
import ViewDocRightSection from '../../../Common/ViewDocRightSection';
import { entityNameEnum } from '@Apis/constants';
import ViewDocumentFooterDetails from '../../../Common/ViewDocFooterLeftSection';
import ViewConsumptionDetails from './ViewConsumptionDetails';
import ViewConsumptionHeader from './ViewConsumptionHeader';
import PRZDrawer from '../../../Common/UI/PRZDrawer';
import ViewConsumptionAddressDetails from './ViewConsumptionAddressDetails';

const ViewConsumption = (props) => {
  const {
    user,
    history,
    isQuickView,
    getAttachmentByIdLoading,
    updateAttachmentLoading,
    getActivityLog,
    getInvoiceByIdLoading,
    selectedInvoice,
    getInvoiceById,
    getInvoiceByIdSuccess,
    updateInvoiceStatusLoading,
    updateInvoiceStatus,
    deleteInvoiceLoading,
    deleteInvoice,
    quickUpdateInvoice,
    updateAttachment,
    getAttachmentById,
    match,
    downloadDocument,
  } = props;

  const [state, setState] = useState({
    isUserReady: false,
    isGetAttachment: false,
    visibleColumns: {
      PRODUCT: { label: 'SKU#', visible: true, disabled: true },
      QUANTITY: { label: 'Quantity', visible: true, disabled: true },
    },
    selectedTags: [],
    fileList: [],
    updateAccountManager: null,
    cfConsumptionLine: null,
    showReturnSlipForm: false,
    showDCDrawer: false,
    openDCModalView: false,
    selectedDCId: null,
  });

  const {
    isUserReady,
    visibleColumns,
    selectedTags,
    fileList,
    cfConsumptionLine,
    showReturnSlipForm,
    showDCDrawer,
    openDCModalView,
    selectedDCId,
  } = state;

  const { consumptionId } = match.params;

  const setConsumptionState = (updates) => {
    setState((prev) => ({ ...prev, ...updates }));
  };

  useEffect(() => {
    getInvoiceById(
      user?.tenant_info?.org_id,
      Helpers.getTenantEntityPermission(
        user?.user_tenants,
        Helpers.permissionEntities.INVOICE,
        Helpers.permissionTypes.READ
      ).join(',') || user?.tenant_info?.tenant_id,
      consumptionId,
      (consumptionData) => {
        setConsumptionState({
          selectedTags: consumptionData?.tags?.length > 0 ? consumptionData?.tags : [],
          fileList: consumptionData?.attachments || [],
        });
      }
    );
    return () => getInvoiceByIdSuccess(null);
  }, []);

  useEffect(() => {
    if (selectedInvoice && !isUserReady) {
      const lineCf = selectedInvoice?.invoice_lines?.[0]?.invoice_line_custom_fields;
      setConsumptionState({
        updateAccountManager: selectedInvoice?.account_manager_id,
        cfConsumptionLine: lineCf,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(lineCf, visibleColumns),
      });
    }
  }, [selectedInvoice, isUserReady]);

  const handleFileChange = (fileListData) => {
    const fileList = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));

    const attachments = fileList?.map((attachment) => ({
      url: attachment?.response?.response?.location || attachment?.url,
      type: attachment.type,
      name: attachment.name,
      uid: attachment.uid,
    }));

    if (['done', 'removed'].includes(fileListData?.file?.status)) {
      const payload = {
        entity_id: selectedInvoice?.invoice_id,
        entity_name: 'invoice',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(selectedInvoice?.invoice_id, 'invoice', () => {
          setConsumptionState({ isGetAttachment: true });
        });
      });
    }

    setConsumptionState({ fileList: attachments.length > 0 ? attachments : [] });
  };

  const quickUpdateDisabled = !(selectedInvoice?.status === 'VOID');
  const hasCoEditAccess = Helpers.getPermission(
    Helpers.permissionEntities.INVOICE,
    Helpers.permissionTypes.UPDATE,
    user
  );
  const fixedMenuBar = user?.side_menu_bar_type === 'FIXED';

  const getLinkedDocumentInfo = () => {
    let linkedDocumentsInfo = [];

    if (selectedInvoice?.credit_notes?.length > 0) {
      const documentDataInfo = selectedInvoice.credit_notes.map((item) => ({
        documentId: item?.cn_id,
        documentNumber: item?.credit_note_number,
        documentStatus: item?.status,
      }));

      linkedDocumentsInfo.push({
        entityName: entityNameEnum.RETURN_SLIP,
        entityVisible: Helpers.getPermission(
          Helpers.permissionEntities.RETURN_SLIP,
          Helpers.permissionTypes.READ,
          user
        ) && selectedInvoice?.custom_status_info?.type === 'CONFIRMED',
        title: 'Return Slips',
        entityNumberPrefix: ' ',
        documentData: documentDataInfo,
        isRedirect: true,
        redirectPath: '/sales/return-slip/view/',
      });
    }

    if (selectedInvoice?.reference_dc?.length > 0) {
      const documentDataInfo = selectedInvoice.reference_dc.map((item) => ({
        documentId: item?.delivery_challan_id,
        documentNumber: item?.dc_number,
        documentStatus: item?.status,
      }));

      linkedDocumentsInfo.push({
        entityName: entityNameEnum.DELIVERY_CHALLAN,
        title: 'DELIVERY CHALLANS',
        entityNumberPrefix: 'DC',
        documentData: documentDataInfo,
        isRedirect: isQuickView,
        isDrawer: !isQuickView,
        drawerState: openDCModalView,
        drawerCallback: (dc, isOpen) =>
          setConsumptionState({ selectedDCId: dc?.documentId, openDCModalView: isOpen }),
        entityVisible: Helpers.getPermission(
          Helpers.permissionEntities.DELIVERY_CHALLAN,
          Helpers.permissionTypes.READ,
          user
        ),
      });
    }

    return linkedDocumentsInfo;
  };

  return (
    <Fragment>
      <div className={`view-document__wrapper ${!isQuickView ? 'view-document__wrapper-page' : ''}`}>
        {!getInvoiceByIdLoading && !updateInvoiceStatusLoading ? (
          <div className="ant-row">
            <div className={`${fixedMenuBar ? 'ant-col-md-16' : 'ant-col-md-17'} ant-col-xs-24`}>
              <div className={`view-left__wrapper ${!isQuickView ? 'is-page-view' : ''}`}>
                <ViewConsumptionHeader
                  {...{
                    selectedInvoice,
                    user,
                    isQuickView,
                    deleteInvoice,
                    deleteInvoiceLoading,
                    updateInvoiceStatus,
                    getInvoiceById,
                    match,
                    history,
                    setShowReturnSlipForm: (val) => setConsumptionState({ showReturnSlipForm: val }),
                    setShowDCDrawer: (val) => setConsumptionState({ showDCDrawer: val }),
                    downloadDocument,
                  }}
                />
                <ViewConsumptionDetails
                  {...{
                    selectedInvoice,
                    quickUpdateInvoice,
                    getActivityLog,
                    getInvoiceById,
                    user,
                    consumptionId,
                  }}
                />
                <ViewConsumptionAddressDetails
                  {...{
                    selectedInvoice,
                  }}
                />
                <br />
                <ConsumptionLinesView
                  consumptionLines={
                    selectedInvoice?.invoice_lines?.map((item) => ({
                      ...item,
                      lineCustomFields: item?.invoice_line_custom_fields,
                    })) || []
                  }
                  selectedSO={selectedInvoice}
                  callback={() =>
                    getInvoiceById(
                      user?.tenant_info?.org_id,
                      Helpers.getTenantEntityPermission(
                        user?.user_tenants,
                        Helpers.permissionEntities.INVOICE,
                        Helpers.permissionTypes.READ
                      ).join(',') || user?.tenant_info?.tenant_id,
                      consumptionId
                    )
                  }
                  cfConsumptionLine={cfConsumptionLine}
                  visibleColumns={visibleColumns}
                  setVisibleColumns={(data) => setConsumptionState({ visibleColumns: data })}
                  callbackState={(val) => setConsumptionState({ isUserReadyForPrefillData: val })}
                  isEditable={quickUpdateDisabled && hasCoEditAccess}
                />
                <div className="view-document__totals-wrapper">
                  <ViewDocumentFooterDetails
                    {...{
                      termsAndConditions: selectedInvoice?.terms_and_conditions,
                      fileList,
                      disableAttachment: getAttachmentByIdLoading || updateAttachmentLoading,
                      onFileChange: handleFileChange,
                      canUpdateAttachment: hasCoEditAccess,
                    }}
                  />
                </div>
              </div>
            </div>
            <ViewDocRightSection
              entityType="INVOICE"
              entityId={selectedInvoice?.invoice_id}
              user={user}
              isQuickView={isQuickView}
              tagSelectorProps={{
                isEnabled: true,
                selectedTags,
                isMultipleTagsAllowed: true,
                tagSearchAllowed: true,
                onChange: (value) => setConsumptionState({ selectedTags: value }),
                placeholder: 'Select Tags',
                disabled: true,
              }}
              activityLogProps={{
                isEnabled: selectedInvoice?.invoice_id,
                entityName: 'Consumption Order',
                entityType: 'consumption_order',
              }}
              linkedDocumentsInfo={getLinkedDocumentInfo()}
            />
          </div>
        ) : (
          <ViewLoadingSkull isQuickView={isQuickView} fixedMenuBar={fixedMenuBar} />
        )}
      </div>

      <PRZDrawer
        open={openDCModalView}
        onClose={() => setConsumptionState({ openDCModalView: false })}
        title="View Delivery Challan"
        width={920}
        headerWidth={870}
      >
        <ViewDeliveryChallan
          selectedDcSourceTenant={selectedInvoice?.source_department_info}
          selectedDCId={selectedDCId}
          callback={() => {
            const { invoiceId, tenantId } = match.params;
            const { selectedInvId, selectedTenantId } = props;
            setConsumptionState({ openDCModalView: false });
            getInvoiceById(
              user?.tenant_info?.org_id,
              isQuickView ? selectedTenantId : tenantId || user?.tenant_info?.tenant_id,
              isQuickView ? selectedInvId : invoiceId
            );
          }}
          selectedDocType="CHL"
          isQuickView
        />
      </PRZDrawer>

      <PRZDrawer
        open={showReturnSlipForm}
        onClose={() => setConsumptionState({ showReturnSlipForm: false })}
        title="Create Return Slip"
        width={1250}
        headerWidth={1200}
      >
        <CreditNoteForm
          selectedInvoiceForCN={selectedInvoice}
          callback={() => {
            const { consumptionId } = match.params;
            const { selectedInvId, selectedTenantId } = props;
            setConsumptionState({ showReturnSlipForm: false });
            getInvoiceById(
              user?.tenant_info?.org_id,
              isQuickView
                ? selectedTenantId
                : Helpers.getTenantEntityPermission(
                  user?.user_tenants,
                  Helpers.permissionEntities.CONSUMPTION_ORDER,
                  Helpers.permissionTypes.READ
                ).join(',') || user?.tenant_info?.tenant_id,
              isQuickView ? selectedInvId : consumptionId
            );
          }}
          isReturnSlip
        />
      </PRZDrawer>

      <PRZDrawer
        open={showDCDrawer}
        onClose={() => setConsumptionState({ showDCDrawer: false })}
        title="Create Delivery Challan"
        width={1200}
        headerWidth={1150}
      >
        <DeliveryChallanForm
          selectedInvoice={selectedInvoice}
          callback={() => {
            setConsumptionState({ showDCDrawer: false });
            getInvoiceById(
              user?.tenant_info?.org_id,
              Helpers.getTenantEntityPermission(
                user?.user_tenants,
                Helpers.permissionEntities.INVOICE,
                Helpers.permissionTypes.READ
              ).join(',') || user?.tenant_info?.tenant_id,
              match?.params?.consumptionId
            );
          }}
          documentType="Invoice"
        />
      </PRZDrawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, AttachmentReducers, InvoiceReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getInvoiceByIdLoading: InvoiceReducers.getInvoiceByIdLoading,
  selectedInvoice: InvoiceReducers.selectedInvoice,
  updateInvoiceStatusLoading: InvoiceReducers.updateInvoiceStatusLoading,
  deleteInvoiceLoading: InvoiceReducers.deleteInvoiceLoading,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getInvoiceById: (orgId, tenantId, invoiceId, callback) => dispatch(InvoiceActions.getInvoiceById(orgId, tenantId, invoiceId, callback)),
  getInvoiceByIdSuccess: (selectedInvoice) => dispatch(InvoiceActions.getInvoiceByIdSuccess(selectedInvoice)),
  updateInvoiceStatus: (payload, callback) => dispatch(InvoiceActions.updateInvoiceStatus(payload, callback)),
  deleteInvoice: (payload, callback) => dispatch(InvoiceActions.deleteInvoice(payload, callback)),
  getAttachmentById: (entityId, entityName, callback) => dispatch(
    AttachmentActions.getAttachmentById(entityId, entityName, callback),
  ),
  updateAttachment: (payload, callback) => dispatch(AttachmentActions.updateAttachment(payload, callback)),
  quickUpdateInvoice: (payload, callback, rollback) => dispatch(InvoiceActions.quickUpdateInvoice(payload, callback, rollback)),
  getActivityLog: (entityId, entityName, page, limit, callback) => dispatch(
    ActivityLogActions.getActivityLog(
      entityId,
      entityName,
      page,
      limit,
      callback,
    ),
  ),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ViewConsumption));